import type { GetServerSideProps, NextPage } from 'next';
import dynamic from 'next/dynamic';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { checkUserAuthOnServer } from '@mwl/core-lib';
import { ComingSoon } from '@/components/ComingSoon/ComingSoon';
import { defaultLocale } from '@/constants';
import { wrapperStore } from '@/store/store';
import { getNamespaces } from '@/utils';
interface SportPageProps {
  redirect?: {
    destination: string;
    permanent: boolean;
  };
}
const Layout = dynamic(() => import('@/Layouts/Layout/Layout').then(mod => mod.Layout));
const SportLayout = dynamic(() => import('@/Layouts/SportLayout/SportLayout').then(mod => mod.SportLayout));
const SportPage = dynamic(() => import('@/modules/sport/pages/SportPage/SportPage').then(module => module.SportPage));
const Sport: NextPage<SportPageProps> = ({
  redirect
}) => {
  if (redirect) {
    return <Layout>
        <ComingSoon />
      </Layout>;
  }
  return <Layout sticky data-sentry-element="Layout" data-sentry-component="Sport" data-sentry-source-file="index.tsx">
      <SportLayout data-sentry-element="SportLayout" data-sentry-source-file="index.tsx">
        <SportPage data-sentry-element="SportPage" data-sentry-source-file="index.tsx" />
      </SportLayout>
    </Layout>;
};
export const getServerSideProps: GetServerSideProps = wrapperStore.getServerSideProps(({
  dispatch
}) => async ({
  locale = defaultLocale,
  req,
  res
}) => {
  await checkUserAuthOnServer({
    dispatch,
    locale,
    res,
    req
  });
  const translations = await serverSideTranslations(locale, getNamespaces('sport'));
  return {
    props: {
      ...translations
    }
  };
});
export default Sport;